import styled from 'styled-components';

const StyledProductcard = styled.a`
	display: inline-flex;
	flex-direction: column;
	width: 100%;
	min-width: 0;

	text-decoration: none;

	&:focus-visible {
		outline: 2px solid var(--color-functional-focus);
	}

	&:focus:not(:focus-visible) {
		outline: none;
	}
`;

export default StyledProductcard;
